/**
 * LoginBanner component
 */

import classNames from 'classnames';
import AppDownloadLinks, { Platforms } from 'components/AppDownloadLinks/AppDownloadLinks';
import { useTranslation } from 'react-i18next';
import { GTM, GTMElements, GTMLocations } from 'utils/analytics';

type Props = {
  className?: string;
};

const LoginBanner = (props: Props) => {
  const { className } = props;
  const { t } = useTranslation();

  // Track if app download links were clicked
  const onPlatformLinkClick = (platform: string) => {
    GTM.elementClicked(platform === Platforms.ANDROID ? GTMElements.PLAYSTORE_LINK : GTMElements.APPSTORE_LINK, GTMLocations.SIGNUP_MODAL);
  };

  return (
    <div className={classNames('loginbanner', className)}>
      <div className="loginbanner-inner">
        <h2>{t('components.login-banner.title')}</h2>
        <p>{t('components.login-banner.description')}</p>
        <div className="appstores-links-holder">
          <AppDownloadLinks onLinkClick={onPlatformLinkClick} />
          <img src={t('components.login-banner.qr-code-src')} alt="" className="loginbanner-qrcode" />
        </div>
      </div>
      <div className="loginbanner-apphand">
        <img src={t('components.login-banner.hand-app-src')} alt="" />
      </div>
    </div>
  );
};

export default LoginBanner;
